export default __webpack_public_path__ + "static/media/fontainebleau8.af68f43e.jpg";